<template>
    <v-navigation-drawer class="app-menu appmenubg" :dark="dark" :color="dark ? 'primary' : ''" overlay-color="#000" width="300" app fixed v-model="show" right :temporary="!permanent" :permanent="permanent">
        <div class="drawer-header" @click="watermarkOpacity = 0.01">
            <span class="watermark small-text" :style="'opacity: ' + watermarkOpacity" @click.stop="showWatermark">[Developed by: Ebrahim Maher]</span>
            <div class=" d-flex justify-space-between align-center px-6 py-4">
                <div class="logo-wrapper">
                    <logo white :width="phoneOnly ? 110 : 126" />
                </div>
                <v-btn large class="mb-1" icon @click.prevent="show=false">
                    <v-icon size="24">mdi-menu</v-icon>
                </v-btn>
            </div>
            
            <!-- <div v-if="isAuthed" class="d-flex align-center py-2 px-7">
                <div class="text-center">
                    <avatar :src="user.avatar" :size="50" :icon-size="35"/>
                </div>
                <div class="mr-2">
                    <div class="user-name mr-2" style="line-height: 1rem">{{user.name}}</div>
                    <v-btn dense small v-if="isAuthed" text @click="logoutDialog = true; show = false">تسجيل الخروج</v-btn>
                </div>
            </div> -->
        </div>
        <!-- <v-divider class="my-2" /> -->

        <v-list nav class="px-4 py-0">
            <!-- <v-divider class="mb-3" /> -->
            <v-list-item v-for="(item, i) in drawerRoutes" v-show="!item.pcOnly || pcOnly" color="primary" :key="i" :disabled="item.disabled" link :to="item.to" exact class="menu-list-item my-0 px-8">
                <v-list-item-icon class="ml-4">
                    <v-icon>{{ item.to && $route.name === item.to.name ? item.icon.replace('-outline', '') : item.icon }}</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title style="font-size: 0.95rem; line-height: 1.4rem">{{item.name}}</v-list-item-title>
                </v-list-item-content>

            </v-list-item>
            
        </v-list>
        <v-divider class="mt-4 mb-5" />
        
        <div class="text-center">
            <img :src="asset('derasatech-logo/logo-white.png', 'img')" style="width: auto; height: 15px; opacity: 0.75" />
            <div style="opacity: 0.5" class="white--text details-text mt-1">جميع الحقوق محفوظة © 2023</div>
        </div>

        <logout-dialog v-model="logoutDialog" />
    </v-navigation-drawer>
    
</template>

<script>
import GlobalMethods from '@/helpers/global-methods'
import GlobalComputed from '@/helpers/global-computed'
import drawerRoutes from '@/helpers/links'
import StoreBadge from '../default/store-badge'
import Avatar from '../default/avatar'
import LogoutDialog from '../default/dialogs/logout'

export default {
    name: 'app-menu',
    props: ['value'],
    data(){
        return {
            show: false,
            watermarkOpacity: 0.01,
            logoutDialog: false,
            dark: true,
        }
    },
    components: {
        Avatar,
        LogoutDialog,
        StoreBadge
    },
    watch :{
        show(show){
            if (!show){
                this.$emit('input', false); // close
            }
        },
        value(show){
            this.show = show;
        }
    },
    computed: {
        activeRoute(){
            return this.$route.name;
        },
        drawerRoutes(){
            const self = this;
            const routes = this.isAuthed ? drawerRoutes.auth : drawerRoutes.guest;
            return routes.filter(route=>{
                return !route.if || self[route.if];
            })
        },
        permanent(){
            return this.pcOnly && this.isAuthed && !this.$route.meta.temporaryMenu;
        },
        showLecturesPurchases(){
            return ['both', 'lectures'].includes(this.appData.courses_pay_types);
        },
        showCoursesPurchases(){
            return ['both', 'course'].includes(this.appData.courses_pay_types);
        },
        ...GlobalComputed
    },
    methods: {
        openRoute(route){
            this.show = false;
            this.$router.push(route);
        },
        showWatermark(){
            this.watermarkOpacity += 0.01;
        },
        openProfile(){
            let isProfile = this.$route.name === 'profile' && this.$route.params.id == this.user.id;
            if (!isProfile){
                this.$router.push({name: 'profile', params: {id: this.user.id}});
            }
        },
        ...GlobalMethods
    }
}
</script>

<style lang="scss" scoped>
.app-menu{
    transition: all 0.35s ease, background-color 0s linear;
    @media(max-width: 960px){
        transition: all 0.25s ease-in-out, background-color 0s linear;
    }
    
    .watermark{
        position: absolute;
        top: 0;
        user-select: none;
        line-height: 1.2rem;
        left: 4px;
        color: #000;
        text-transform: capitalize;
        z-index: 7;
    }
    .v-list-item.menu-list-item{
        margin-top: 5px!important;
        opacity: 0.7;
        height: 45px!important;
        
        &.v-list-item--active{
            opacity: 1;
        }
        &.theme--dark{
            &.v-list-item--active:hover::before, &.v-list-item--active::before{
                opacity: 0.12;
            }
            &.v-list-item--active:hover::before, &.v-list-item--active::before{
                opacity: 0.12;
            }
            &:focus::before{
                opacity: 0.1;
            }
            &:active::before{
                opacity: 0.15!important;
            }
        }
    }
}
</style>